// Noms des jetons de taille de la charte (spec 159). Les VALEURS vivent dans `src/index.css` (`--fs-<nom>`, et les
// utilitaires Tailwind `text-<nom>`) ; ce module ne porte que leurs NOMS, pour les deux lecteurs qui en ont besoin :
// `cn()` (tailwind-merge doit savoir que `text-small` est une taille, pas une couleur) et la garde typographique.
export const FONT_SIZE_TOKENS = ['caption', 'small', 'body', 'lead', 'h3', 'h2', 'h1', 'kpi', 'display', 'glyph'] as const

export type FontSizeToken = (typeof FONT_SIZE_TOKENS)[number]
